var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.827 12.5L9.70913 15.4027C9.56971 15.5324 9.5 15.6829 9.5 15.854C9.5 16.0251 9.56971 16.1755 9.70913 16.3053C9.84854 16.4351 10.0101 16.5 10.1939 16.5C10.3777 16.5 10.5393 16.4351 10.6787 16.3053L14.2909 12.9425C14.4303 12.8127 14.5 12.6652 14.5 12.5C14.5 12.3348 14.4303 12.1873 14.2909 12.0575L10.6787 8.69469C10.5393 8.5649 10.3809 8.5 10.2034 8.5C10.026 8.5 9.86755 8.5649 9.72814 8.69469C9.58872 8.82448 9.51901 8.97493 9.51901 9.14602C9.51901 9.31711 9.58872 9.46755 9.72814 9.59735L12.827 12.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAll);
export default __webpack_public_path__ + "static/media/showAll.d3d2566a8c9e45e396c976d13f83118e.svg";
export { ForwardRef as ReactComponent };